import { Popover as BasePopover } from '@base-ui/react/popover'
import type { ComponentPropsWithoutRef, ReactElement, ReactNode } from 'react'

export type PopupClassNames = {
  trigger?: string
  positioner?: string
  popup?: string
  arrow?: string
}

type PopupPositionerProps = Omit<
  ComponentPropsWithoutRef<typeof BasePopover.Positioner>,
  'children' | 'className'
>

export type PopupProps = {
  children: ReactNode
  trigger: ReactElement
  classNames?: PopupClassNames
  portalToRoot?: boolean
  positionerProps?: PopupPositionerProps
  open?: boolean
  defaultOpen?: boolean
  onOpenChange?: ComponentPropsWithoutRef<
    typeof BasePopover.Root
  >['onOpenChange']
}

export function Popup({
  children,
  trigger,
  classNames,
  portalToRoot = false,
  positionerProps,
  open,
  defaultOpen,
  onOpenChange,
}: PopupProps) {
  return (
    <BasePopover.Root
      open={open}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
    >
      <BasePopover.Trigger className={classNames?.trigger} render={trigger} />
      <BasePopover.Portal
        container={portalToRoot ? document.getElementById('root') : undefined}
      >
        <BasePopover.Positioner
          sideOffset={8}
          {...positionerProps}
          className={classNames?.positioner}
        >
          <BasePopover.Popup className={classNames?.popup}>
            {children}
            {classNames?.arrow !== undefined && (
              <BasePopover.Arrow className={classNames.arrow} />
            )}
          </BasePopover.Popup>
        </BasePopover.Positioner>
      </BasePopover.Portal>
    </BasePopover.Root>
  )
}
